import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useCategoryStore } from "../../hooks/useCategoryStore";
import { CategoryModal } from "./components/CategoryModal";
import CategoryIcon from '@mui/icons-material/Category';
import { ShowSubcategoriesModal } from "./components/ShowSubcategoriesModal";
import { RoutesMap } from "../../types";
import { useImportStore } from "../../hooks/useImportStore";
import { DrawerDuplicated } from "./components/DrawerDuplicated";
import { DrawerOptimizated } from "./components/DrawerOptimizated";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Familias', pathname: RoutesMap.CATEGORIES }
]

export const CategoryView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionCategory, getCategories, getCategoriesByCompany, deleteCategory } = useCategoryStore();
    const { status: statusImport, downloadTemplate } = useImportStore()

    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalSubcategories, setShowModalSubcategories] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [showDuplicated, setShowDuplicated] = useState<boolean>(false)
    const [showOptimizated, setShowOptimizated] = useState<boolean>(false)

    useEffect(() => {
        getCategoriesApi()
    }, [])

    const getCategoriesApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getCategoriesByCompany(search);
            if (!response) {
                setCategories([]);
                setLoading(false);
                return false;
            } else {
                setCategories(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionCategory('add');
        setShowModal(true);
    }

    const onEdit = (rowSelected: any) => {
        setActionCategory('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionCategory('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionCategory('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const showSubCategories = (rowSelected) => {
        setRowSelected(rowSelected);
        setShowModalSubcategories(true);
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteCategory(rowSelected.id)
            if (response) {
                getCategoriesApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getCategoriesApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    const downloadTemplateApi = async () => {
        const url: string | false = await downloadTemplate(5) //5: categorias
        if (url === false) return

        const win: any = window.open(`${process.env.REACT_APP_ROOT_URL}` + url)
        win.focus()
    }

    const onImport = async (event) => {
        const file = event.target.files[0]
        if (file) {

        }
    }

    const showDrawerDuplicated = () => {
        setShowDuplicated(true)
    }

    const showDrawerOptimizated = () => {
        setShowOptimizated(true)
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Familias'}
                    columns={columns}
                    loading={loading}
                    rows={categories || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva familia'}
                    // onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onHelper={showSubCategories}
                    icon_helper={<CategoryIcon fontSize="small" />}
                    tooltip_helper={'subfamilias'}
                    onSearch={onSearch}
                    dense
                    onImport={onImport}
                    template={downloadTemplateApi}
                    textInfo={'Existen familias con duplicadas'}
                    redirecInfo={showDrawerDuplicated}
                    textRedirect={'Ver familias duplicadas'}
                    textInfo2={'Existe data a optimizar'}
                    redirecInfo2={showDrawerOptimizated}
                    textRedirect2={'Ver data a optimizar'}
                />
            </Grid>
            {
                showModal && (
                    <CategoryModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        categorySelected={rowSelected}
                        listcategories={getCategoriesApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                        clearState={clearState}

                    />
                )
            }
            {
                showModalSubcategories && (
                    <ShowSubcategoriesModal
                        open={showModalSubcategories}
                        closeModal={() => { setShowModalSubcategories(false) }}
                        categorySelected={rowSelected}
                        clearState={clearState}
                    />
                )
            }
            {
                showDuplicated && (
                    <DrawerDuplicated
                        open={showDuplicated}
                        closeModal={()=>{setShowDuplicated(false)}}
                    />
                )
            }
            {
               showOptimizated  && (
                    <DrawerOptimizated
                     open={showOptimizated}
                     closeModal={()=>{setShowOptimizated(false)}}
                     />
                )
            }
        </>
    )
}